import { dictionaryApi } from './dictionaryClient';
import { normalizeAdhikar, type Adhikar } from './ashtadhyayiApi';

export type { Adhikar };

export type CreateAdhikarBody = {
  ashtadhyayiSutraId: number;
  order: number;
  text: string;
  link?: number | null;
};

export type UpdateAdhikarBody = Partial<Omit<CreateAdhikarBody, 'ashtadhyayiSutraId'>>;

function isRecord(x: unknown): x is Record<string, unknown> {
  return x != null && typeof x === 'object' && !Array.isArray(x);
}

function unwrapEntityPayload(raw: unknown): unknown {
  if (isRecord(raw) && 'data' in raw) return raw.data;
  return raw;
}

function normalizeList(data: unknown): Adhikar[] {
  const rows =
    Array.isArray(data) ? data : isRecord(data) && Array.isArray(data.data) ? (data.data as unknown[]) : [];
  return rows
    .map(normalizeAdhikar)
    .filter((x): x is Adhikar => x != null)
    .sort((a, b) => a.order - b.order);
}

export async function listAdhikar(ashtadhyayiSutraId?: number): Promise<Adhikar[]> {
  const params =
    ashtadhyayiSutraId != null && Number.isFinite(ashtadhyayiSutraId)
      ? { ashtadhyayiSutraId }
      : undefined;
  const res = await dictionaryApi.get<unknown>('/ashtadhyayi-adhikar', { params });
  return normalizeList(res.data);
}

export async function getAdhikar(id: number): Promise<Adhikar> {
  const res = await dictionaryApi.get<unknown>(`/ashtadhyayi-adhikar/${id}`);
  const row = normalizeAdhikar(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid adhikāra response');
  return row;
}

export async function createAdhikar(body: CreateAdhikarBody): Promise<Adhikar> {
  const res = await dictionaryApi.post<unknown>('/ashtadhyayi-adhikar', body);
  const row = normalizeAdhikar(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid adhikāra response');
  return row;
}

export async function updateAdhikar(id: number, body: UpdateAdhikarBody): Promise<Adhikar> {
  const res = await dictionaryApi.patch<unknown>(`/ashtadhyayi-adhikar/${id}`, body);
  const row = normalizeAdhikar(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid adhikāra response');
  return row;
}

export async function deleteAdhikar(id: number): Promise<void> {
  await dictionaryApi.delete(`/ashtadhyayi-adhikar/${id}`);
}
